module.exports = __webpack_public_path__ + "static/media/suavizador.c049b6c7.pdf";